import { render, staticRenderFns } from "./pravnicka_osoba.vue?vue&type=template&id=92c59606&"
import script from "./pravnicka_osoba.vue?vue&type=script&lang=js&"
export * from "./pravnicka_osoba.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\azagent\\_work\\3\\s\\master-v3\\Filip.Client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('92c59606')) {
      api.createRecord('92c59606', component.options)
    } else {
      api.reload('92c59606', component.options)
    }
    module.hot.accept("./pravnicka_osoba.vue?vue&type=template&id=92c59606&", function () {
      api.rerender('92c59606', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/pravnicka_osoba.vue"
export default component.exports